import { render, staticRenderFns } from "./ChangePaymentMethodDialog.vue?vue&type=template&id=5016f52b&scoped=true&"
import script from "./ChangePaymentMethodDialog.vue?vue&type=script&lang=js&"
export * from "./ChangePaymentMethodDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChangePaymentMethodDialog.vue?vue&type=style&index=0&id=5016f52b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016f52b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VProgressCircular})
